import React from 'react';
import { useStore } from '../../context/appContext';
// components
import Modal from '../../components/Modal';
import steps from './views';

function Main(props) {
  const { step } = useStore();
  const Content= steps[step - 1];
  
  return (
    <>
      <Content {...props} />
      <Modal />
    </>
  );
}

export default Main;
